import {JsonProperty} from '@hyperloris/tyson';
import {Trade} from "./trade";
import Side = Trade.Side;


export class ClearingSelectionSummary {

  @JsonProperty()
  side: Side;

  @JsonProperty()
  selectionCount: number;

  @JsonProperty()
  totalVolume: number;

  @JsonProperty()
  apsGrpTotalVolume: number;

  @JsonProperty()
  totalPrice: number;

  @JsonProperty()
  apsGrpTotalPrice: number;

  constructor(side: Side) {
    this.apsGrpTotalVolume = 0;
    this.apsGrpTotalPrice = 0;
    this.totalVolume = 0;
    this.totalPrice = 0;
    this.selectionCount = 0;
    this.side = side;
  }

}
